import { useGet } from '../useGet';

const API_URL = import.meta.env.VITE_API_URL;

export function useObterTotalPastasAtivasPorGerencia() {
  return useGet({
    url: `${API_URL}/pastas/obter-total-pastas-ativas-por-gerencia`,
    config: {
      getAccessToken: true,
      timeout: 120000,
    },
    onlyLast: true,
  });
}
